<template>
  <div class="AddSceneButtonWidget lxn-w100 lxn-viewWithMaxWidth lxn-margin-auto">
    <div class="AddSceneButtonWidget-topCurve-wrapper lxn-w100">
      <CustomCurve>
          <TopNav @leftTextClick="goBack" :leftText="$store.getters.language.texts.LoginRegister_back" leftIcon="arrowLeft" centerText="" rightText=""></TopNav>
      </CustomCurve>
    </div>
    <div class="AddSceneButtonWidget-main lxn-pos-rel">
      <div class="AddSceneButtonWidget-main-wrapper lxn-margin-auto lxn-border-round">
        <TitleBox :titleBgColor="titleBgColor" bgColor="#ECECEC">
          <template v-slot:title>
            {{$store.getters.language.texts.EditWidget_title1}}
          </template>
          <template v-slot:body>
            <div class="AddSceneButtonWidget-wrapper-colors lxn-w100">
              <div @click="activeBoxIndex = 0;" class="AddSceneButtonWidget-color color1 lxn-h100 lxn-border-round lxn-float-right" :style="boxStyle(0)" :class="isBoxActive(0)">
                <div class="AddSceneButtonWidget-selectedColor lxn-w100 lxn-h100 lxn-border-round">
                </div>
              </div>
              <div @click="activeBoxIndex = 1;" class="AddSceneButtonWidget-color color2 lxn-h100 lxn-border-round lxn-float-right" :style="boxStyle(1)" :class="isBoxActive(1)">
                <div class="AddSceneButtonWidget-selectedColor lxn-w100 lxn-h100 lxn-border-round">
                </div>
              </div>
              <div @click="activeBoxIndex = 2;" class="AddSceneButtonWidget-color color3 lxn-h100 lxn-border-round lxn-float-right" :style="boxStyle(2)" :class="isBoxActive(2)">
                <div class="AddSceneButtonWidget-selectedColor lxn-w100 lxn-h100 lxn-border-round">
                </div>
              </div>
              <div @click="activeBoxIndex = 3;" class="AddSceneButtonWidget-color color4 lxn-h100 lxn-border-round lxn-float-right" :style="boxStyle(3)" :class="isBoxActive(3)">
                <div class="AddSceneButtonWidget-selectedColor lxn-w100 lxn-h100 lxn-border-round">
                </div>
              </div>
              <div @click="activeBoxIndex = 4;" class="AddSceneButtonWidget-color color5 lxn-h100 lxn-border-round lxn-float-right" :style="boxStyle(4)" :class="isBoxActive(4)">
                <div class="AddSceneButtonWidget-selectedColor lxn-w100 lxn-h100 lxn-border-round">
                </div>
              </div>
            </div>
            <div class="AddSceneButtonWidget-wrapper-name-text lxn-w100 lxn-text" :class="[$store.getters.language.font, $store.getters.language.directionClass, $store.getters.language.textAlignClass]">
              {{$store.getters.language.texts.Name_text}}
            </div>
            <div class="lxn-w100">
              <customInput @focus="input1State='active'" @blur="input1State=''" :inputState="input1State" v-model="WidgetName" bgColor="#FFFFFF" :placeHolder="$store.getters.language.texts.WidgetName_PlaceHolder" inputType="text" />
            </div>
          </template>
        </TitleBox>
        <CommandCreator v-model="generatedCommand" :titleBgColor="titleBgColor" :multiHub="true" :outputsOnly="true" />
      </div>
      <div class="AddSceneButtonWidget-button lxn-margin-auto lxn-w100">
        <CustomButton @click="saveChanges" bgColor="#1EA5DE" iconRight="arrowRight" iconRightColor="#1EA5DE" iconRightBgColor="#D5E6F0" textColor="#FFFFFF" :iconRightPadding="8" :useLanguageDirection="true">
          {{$store.getters.language.texts.AddSceneButtonWidget_button}}
        </CustomButton>
      </div>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
import CommandCreator from '@/components/CommandCreator.vue'
import CustomButton from '@/components/CustomButton.vue'
import CustomCurve from '@/components/CustomCurve.vue'
import CustomInput from '@/components/CustomInput.vue'
import TitleBox from '@/components/TitleBox.vue'
import TopNav from '@/components/TopNav.vue'

export default {
  name: 'AddSceneButtonWidget',
  components: {
    CustomCurve,
    TopNav,
    CustomButton,
    TitleBox,
    CustomInput,
    CommandCreator
  },
  data: function () {
    return {
      WidgetName: '',
      input1State: '',
      activeBoxIndex: 0,
      generatedCommand: [],
    }
  },
  mounted: function () {
  },
  watch: {
  },
  computed: {
    titleBgColor: function () {
      return this.$store.state.themeMainColors[this.activeBoxIndex];
    },
  },
  methods: {
    goBack: function () {
      this.$router.go(-1);
    },
    boxStyle: function (boxIndex) {
      return "background-color: " + this.$store.state.themeMainColors[boxIndex];
    },
    isBoxActive: function (boxIndex) {
      if(this.activeBoxIndex == boxIndex) {
        return 'active';
      }else{
        return '';
      }
    },
    saveChanges: function () {
      this.input1State = '';
      if(this.WidgetName == ''){
        this.input1State = 'error';
        alert(this.$store.getters.language.texts.WidgetName_alert);
      }else if(this.generatedCommand.length == 0){
        alert(this.$store.getters.language.texts.CommandCreator_alert2);
      }else{
        this.$store.commit('setAppBusy', true);
        var hubUUIDs = [];
        for(var i = 0; i < this.generatedCommand.length; i++){
          hubUUIDs.push(this.generatedCommand[i].hubUUID);
        }
        this.$store.commit('addWidget', {
          name: this.WidgetName,
          color: this.activeBoxIndex,
          type: "sceneButtonWidget",
          hubUUIDs: hubUUIDs,
          //For compatibility with other widgets
          hubUUID: hubUUIDs[0],
          visible: true,
          path: this.$store.state.activeDashboardFolderId,
          settings: {
            commands: this.generatedCommand,
          }
        });
        this.$store.commit('saveState');
        this.$router.push('/home/dashboard/');
        this.$store.commit('setAppBusy', false);
      }
    },
  }
}
</script>

<style>
  .AddSceneButtonWidget-topCurve-wrapper {
    height: 200px;
  }
  .AddSceneButtonWidget-main {
    z-index: 2;
  }
  .AddSceneButtonWidget-main-wrapper {
    width: calc(100% - 36px);
    margin-top: -150px;
    z-index: 2;
    background-color: #ffffff;
    margin-bottom: 14px;
    padding: 14px;
  }
  .AddSceneButtonWidget-button {
    width: calc(100% - 36px);
    margin-bottom: 14px;
  }
  .AddSceneButtonWidget-wrapper-colors {
    height: 50px;
  }
  .AddSceneButtonWidget-color {
    width: calc((100% - 32px)/5);
    margin-left: 8px;
    padding: 5px;
  }
  .AddSceneButtonWidget-selectedColor {
    background-color: transparent;
    border-style: solid;
    border-color: #FFFFFF;
    border-width: 4px;
    opacity: 0;
  }
  .AddSceneButtonWidget-color.active .AddSceneButtonWidget-selectedColor {
    opacity: 1;
  }
  .AddSceneButtonWidget-color:last-child {
    width: calc((100% - 32px)/5);
    margin-left: 0;
  }
  .AddSceneButtonWidget-wrapper-name-text {
    height: 50px;
    padding-top: 20px;
    line-height: 30px;
    color: #52626C;
  }
  .AddSceneButtonWidget-wrapper-name-text:first-child {
    height: 30px;
    padding-top: 0;
  }
  .AddSceneButtonWidget-wrapper-fieldTitles {
    height: 30px;
    line-height: 30px;
    color: #52626C;
  }
  .AddSceneButtonWidget-commandDelay-button {
    -webkit-appearance: none;
    transition: opacity 0.5s ease;
    background: #1EA5DE;
    border: 0;
    border-radius: 7px;
    overflow: hidden;
    color: #fff;
    cursor: pointer;
    float: left;
    font-size: 20px;
    height: 40px;
    margin: 0;
    width: 40px;
  }
  .AddSceneButtonWidget-commandDelay-button:hover {
    opacity: 0.5;
  }
  .AddSceneButtonWidget-commandDelay-button:hover {
    opacity: 0.5;
  }
  .AddSceneButtonWidget-commandDelay-button:focus {
      outline: 0;
      outline-offset: 0;
  }
  .AddSceneButtonWidget-wrapper-button2 {
    width: calc(100% - 36px);
    margin-top: 25px;
    margin-bottom: 14px;
  }
  .AddSceneButtonWidget-wrapper-commands {
    height: 70px;
    background-color: #FFFFFF;
    padding: 5px;
    margin-top: 14px;
  }
  .AddSceneButtonWidget-wrapper-commands:first-child {
    margin-top: 0;
  }
  .AddSceneButtonWidget-wrapper-command {
    height: 20px;
    line-height: 20px;
  }
  .AddSceneButtonWidget-wrapper-commands-trash {
    left: 5px;
    top: 5px;
    width: 30px;
    height: 30px;
  }
</style>
